import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Image from '../Common/Image'
import Icon from '../Common/Icon'
import purifyHTML from '../../utils/purifyHTML';

export default class Travelservices extends Component {
  static propTypes = {
    config: PropTypes.object,
  }

  constructor() {
    super()
    this.state = {
      open: undefined
    }
  }

  toggle = () => {
    this.setState({
      open: (this.state.open !== undefined) ? !this.state.open : !this.props.config.open
    })
  }

  render() {
    const {
      config,
      loading
    } = this.props
    let {
      title = 'Travelservices',
      linkTextAboutScreenReaderText,
      services,
      open
    } = config

    if (this.state.open !== undefined) {
      open = this.state.open
    }

    if (!services || !services.length)
      return null

    return (
      <div className="container container--center container--margin">
        <div className={`reisadvies-services accordion__item ${loading ? 'reisadvies-services--loading' : ''} ${open ? 'is-expanded' : 'is-collapsed'}`}>
          <button className="reisadvies-services__toggle-btn accordion__btn" onClick={this.toggle}>
            <h2 className="reisadvies-services__title accordion__title">{title}</h2>
            <Icon className="reisadvies-services__indicator accordion__indicator" iconName="chevron-up" />
          </button>
          <div className="reisadvies-services__content accordion__content">
            <table className="reisadvies-services__list">
              <tbody>
                {services.map(({
                  imageUrl,
                  name,
                  description,
                  linkUrl,
                  linkText
                }) => {
                  const cleanName = purifyHTML(name)
                  const cleanDescription = purifyHTML(description)
                  return (
                    <tr className="reisadvies-services__item" key={name}>
                      <td className="reisadvies-services__image-wrapper">
                        {
                          !imageUrl ? null : (
                            <Image className="reisadvies-services__image" src={imageUrl} />
                          )
                        }
                      </td>
                      <td className="reisadvies-services__name" dangerouslySetInnerHTML={cleanName}></td>
                      <td className="reisadvies-services__description" dangerouslySetInnerHTML={cleanDescription}></td>
                      <td className="reisadvies-services__more-info">
                        <a href={linkUrl} rel="noopener" target="_blank">{linkText} <span className="sr-only"> {linkTextAboutScreenReaderText} {name}</span></a>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Reisadviezen/Travelservices.js